import { apiClient, apiClientForCourses, baseForPdf } from '../apiClients';
import { fetchAndCache } from '../../components/shared/CacheStroage';
import { Endpoints } from '../../network';

interface ICallBackData {
  name: string;
  email: string;
  product_id: number;
  zl_uid: string;
  country_code: string;
  phone: string;
}

export const getAllCourse = async ({
  page,
  categoriesId = null,
  keyword,
  limit,
}: {
  page: string;
  categoriesId: string | null;
  keyword?: string;
  limit?: string;
}) => {
  const queryParams = new URLSearchParams({
    page,
    ...(categoriesId !== 'undefined' &&
      categoriesId !== null && { category: categoriesId }),
    ...(keyword !== undefined && { search: keyword }),
    ...(limit !== undefined && { limit }),
  });
  const apiCall = async () => {
    const response = await apiClientForCourses.get(
      `${Endpoints.getAllCourses}?${queryParams}`,
    );
    return response?.data;
  };
  return fetchAndCache(
    apiCall,
    `${Endpoints.getAllCourses}?${queryParams}`,
    page,
  );
};

export const getMyCourses = async (searchQuery?: string) => {
  let url = Endpoints.getMyCourses;
  if (searchQuery) {
    url += `?search=${encodeURIComponent(searchQuery)}`;
  }
  const response = await apiClientForCourses.get(url);

  return response?.data;
};

export const getCoursesAllCategories = async () => {
  const response = await apiClientForCourses.get(
    `${Endpoints.coursesAllCategories}`,
  );
  return response?.data;
};

export const syncCourses = async () => {
  const response = await apiClientForCourses.get(`${Endpoints.syncCourses}`);

  return response?.data;
};

export const getCourseReaderList = async ({
  page,
  limit,
  keyword,
  categoriesId = null,
  duration,
  level,
  sessionType,
  sortBy,
  priceMin,
  authorId,
}: {
  page: string;
  limit?: string;
  keyword?: string;
  categoriesId?: string | null;
  duration?: string[];
  level?: string[];
  sessionType?: string[];
  sortBy?: string;
  priceMin?: string;
  authorId?: string;
}) => {
  const queryParams = new URLSearchParams();

  queryParams.append('page', page);

  if (limit) queryParams.append('limit', limit);
  if (keyword) queryParams.append('search', keyword);
  if (categoriesId && categoriesId !== 'undefined') {
    queryParams.append('category', categoriesId);
  }

  if (duration && duration.length > 0) {
    queryParams.append('duration', duration.join(','));
  }
  if (priceMin) {
    queryParams.append('priceMin', priceMin);
  }

  if (level && level.length > 0) {
    queryParams.append('level', level.join(','));
  }

  if (sessionType && sessionType.length > 0) {
    queryParams.append('sessionType', sessionType.join(','));
  }

  if (sortBy) queryParams.append('sortBy', sortBy);
  if (authorId) queryParams.append('authorId', authorId);

  const apiCall = async () => {
    const response = await baseForPdf.get(
      `${Endpoints.getCourseReaderList}?${queryParams.toString()}`,
    );
    return response?.data;
  };

  return fetchAndCache(
    apiCall,
    `${Endpoints.getCourseReaderList}?${queryParams.toString()}`,
    page,
  );
};

export const requestCallBack = async (data: ICallBackData) => {
  const response = await apiClient.post(`${Endpoints.requestCallBack}`, data);
  return response?.data;
};

export const getCallBackList = async (product_id: number) => {
  const response = await apiClient.get(
    `${Endpoints.checkCallBackRequest}`,
    product_id ? { params: { product_id } } : undefined,
  );
  return response?.data;
};

export const getCourseBySlug = async (slug: string) => {
  const response = await apiClientForCourses.get(Endpoints.getCourseBySlug(slug));
  return response?.data;
};

export const getResources = async (topicId: string | number) => {
  const response = await apiClientForCourses.get(Endpoints.getResources(topicId));
  return response?.data;
};

export const readFileUrl = async (fileId: string | number) => {
  const response = await apiClientForCourses.post(Endpoints.readFileUrl, { fileId });
  return response?.data;
};

export const userTrackHandle = async (topicId: string | number, isWatched: string | number) => {
  const response = await apiClientForCourses.post(Endpoints.userTrackHandle, { topicId, isWatched });
  return response?.data;
};

export const updateDuration = async (courseId: string | number, completion: number) => {
  const response = await apiClientForCourses.put(Endpoints.updateDuration, { courseId, completion });
  return response?.data;
};

export const getCertificate = async (courseId: string | number) => {
  const response = await apiClientForCourses.post(Endpoints.getCertificate, { courseId });
  return response?.data;
};

